import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'
import { useEffect } from 'react'

export function useDataDog() {
  const DATADOG_CLIENT_TOKEN_ID = process.env.DD_TOKEN
  const ENV = process.env.APP_ENV === 'production' ? 'prod' : process.env.APP_ENV

  useEffect(() => {
    if (DATADOG_CLIENT_TOKEN_ID) {
      datadogRum.init({
        applicationId: 'dbd281b2-69e3-41d0-b8f9-bdf3a5275de4',
        clientToken: DATADOG_CLIENT_TOKEN_ID,
        defaultPrivacyLevel: 'mask-user-input',
        env: ENV,
        site: 'datadoghq.com',
        service: 'mission-control',
        sessionSampleRate: 50,
        sessionReplaySampleRate: 25,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
      })

      datadogRum.startSessionReplayRecording()

      datadogLogs.init({
        clientToken: DATADOG_CLIENT_TOKEN_ID,
        env: ENV,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        service: 'mission-control',
        silentMultipleInit: true,
        site: 'datadoghq.com',
      })
    }
  }, [ENV, DATADOG_CLIENT_TOKEN_ID])
}
